<template>
    <div class="tw-py-8 tw-w-full">
        <div id="dayCard" class="tw-flex tw-justify-between">
            <div @click="toggleCards" class="tw-flex tw-items-center tw-cursor-pointer" style="min-width: 7.5rem;">
                <div class="tw-w-8 tw-h-full tw-mr-2">
                    <div :id="idDown" class="tw-w-full tw-h-full" style="background: url(/img/angle-down.svg) center/60% no-repeat;"></div>
                    <div :id="idUp" class="tw-w-full tw-h-full tw-hidden" style="background: url(/img/angle-up.svg) center/60% no-repeat;"></div>
                </div>
                <div class="">
                    <span><slot name="workdate"></slot></span>
                </div>
            </div>
            <div class="tw-flex">
                <button class="tw-px-4 tw-py-1 tw-bg-green-500 tw-rounded" style="max-height: 2rem;">
                    <span class="tw-text-white">Bestätigt</span>
                </button>
                <button class="tw-w-4 tw-h-full tw-ml-4"  style="background: url(/img/more-alt.svg) center/40% no-repeat;"></button>
            </div>
        </div>
        <div  v-if="show" v-for="post in posts">
            <div class="totalworktime-postCard tw-mt-10">
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Projekt</span>
                    <span class="postCard-content">{{post.cost_carrier.parent.name}}</span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Kategorie</span>
                    <span class="postCard-content">{{post.cost_carrier.name}}</span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <!--<span class="postCard-label tw-ml-10">Ticket-Nr.</span> BREAKS STAGING SERVER
                    <span class="postCard-content postCard-ticket">{{ticketLabel_formatted(post)}}<a :href="ticket_path">{{ticketLink_formatted(post)}}</a></span></span>-->
                    <span class="postCard-label tw-ml-10">Ticket-Nr.</span>
                    <span class="postCard-content postCard-ticket">{{ticketLabel_formatted(post)}}<a href="#">{{ticketLink_formatted(post)}}</a></span></span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Beschreibung</span>
                    <span class="postCard-content">{{post.description}}</span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Start</span>
                    <span class="postCard-content">{{post.time_start ? duration_formatted(post.time_start) : ' - ' }}</span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Ende</span>
                    <span class="postCard-content">{{post.time_end ? duration_formatted(post.time_end) : ' - ' }}</span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Pause</span>
                    <span class="postCard-content">{{post.break ? (post.break.toString() + 'm') : ' - ' }}</span>
                </div>
                <div class="postCard-object tw-mt-2">
                    <span class="postCard-label tw-ml-10">Gesamt</span>
                    <span class="postCard-content">{{ time_formatted(post.hours) }}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'FoldOutCard',
        props: {
            posts: Array,
        },
        data() {
            return {
                id: null,
                idUp: '',
                idDown: '',
                show: false,
                ticket_path: '',
            }
        },
        mounted() {
            this.id = this._uid;
            this.idUp = this._uid.toString() + '-icon-up';
            this.idDown = this._uid.toString() + '-icon-down';
            this.idPostCards = this._uid.toString() + 'postCards';
        },
        methods: {
            toggleCards() {
                if(getComputedStyle(document.getElementById(this.idUp), null).display === "none") {
                    // toggle icon
                    document.getElementById(this.idUp).style.display = "block";
                    document.getElementById(this.idDown).style.display = "none";
                    // toggle cards
                    this.show = true;
                } else {
                    // toddle icon
                    document.getElementById(this.idUp).style.display = "none";
                    document.getElementById(this.idDown).style.display = "block";
                    // toggle cards
                    this.show = false;
                }
            },
            time_formatted(phours) {
                // get hours and minutes
                let time_raw = phours;
                let hours = Math.floor(time_raw);
                let minutes = Math.round((time_raw - hours) * 60);
                // format the returned string
                if(hours === 0) return minutes + 'm';
                if(minutes === 0) return hours + 'h';
                return hours + 'h ' + minutes + 'm';
            },
            duration_formatted(str) {
                // '2020-03-02 00:00:00'
                // \d - [0-9]
                // \s - Leerzeichen
                // delete the '2020-03-02 ' part
                let removeFirst = str.replace(/\d\d\d\d-\d\d-\d\d\s/, "");
                // remove the seconds part '01:02:03' -> '01:02'
                let seperated = removeFirst.split(/:/);
                let newStr = seperated[0] + ":" + seperated[1];
                return newStr;
            },
            ticketLabel_formatted(post) {
                if(post.jira_ticket_id) return 'Jira: ';
                else if(post.trello_ticket_id) return 'Trello: ';
                return ' - ';
            },
            ticketLink_formatted(post) {
                if(post.jira_ticket_id) {
                    // set ticket path
                    let url = '/ticket/jira/' + post.project_id + '/' + post.cost_carrier.id + '/' + post.jira_ticket_id;
                    this.ticket_path = url;
                    // return ticket id
                    return post.jira_ticket_id;
                } 
                else if(post.trello_ticket_id) {
                    // set ticket path
                    let url = '/ticket/trello/' + post.project_id + '/' + post.cost_carrier.id + '/' + post.trello_ticket_id;
                    this.ticket_path = url;
                    // return ticket id 
                    return post.trello_ticket_id;
                }
                return '';
            },
        },
    }
</script>